import React from "react";
import { RouteObject, Navigate } from "react-router-dom";
import { lazyWithRetry as lazy } from "@src/utils/CommonUtils";
import LazyWrapper from "@src/components/lazy-wrapper/LazyWrapper";

const TodayPage = lazy(() =>
  import("./pages/TodayPage").then((m) => ({ default: m.TodayPage }))
);
const LandingPage = lazy(() =>
  import("./pages/LandingPage").then((m) => ({ default: m.LandingPage }))
);
const CompaniesPage = lazy(() =>
  import("./pages/CompaniesPage").then((m) => ({ default: m.CompaniesPage }))
);
const CompanyDetailPage = lazy(() =>
  import("./pages/CompanyDetailPage").then((m) => ({
    default: m.CompanyDetailPage,
  }))
);
const CompanyBankPage = lazy(() =>
  import("./pages/CompanyBankPage").then((m) => ({
    default: m.CompanyBankPage,
  }))
);
const CompanyQuestionPage = lazy(() =>
  import("./pages/CompanyQuestionPage").then((m) => ({
    default: m.CompanyQuestionPage,
  }))
);
const CompanyRecentRoundPage = lazy(() =>
  import("./pages/CompanyRecentRoundPage").then((m) => ({
    default: m.CompanyRecentRoundPage,
  }))
);
const PlatformsPage = lazy(() =>
  import("./pages/PlatformsPage").then((m) => ({ default: m.PlatformsPage }))
);
const PlatformDetailPage = lazy(() =>
  import("./pages/PlatformDetailPage").then((m) => ({
    default: m.PlatformDetailPage,
  }))
);
const PlatformProblemPage = lazy(() =>
  import("./pages/PlatformProblemPage").then((m) => ({
    default: m.PlatformProblemPage,
  }))
);
const PracticePage = lazy(() =>
  import("./pages/PracticePage").then((m) => ({ default: m.PracticePage }))
);
const DreamCompanyPage = lazy(() =>
  import("./pages/DreamCompanyPage").then((m) => ({
    default: m.DreamCompanyPage,
  }))
);
const RadarPage = lazy(() =>
  import("./pages/RadarPage").then((m) => ({ default: m.RadarPage }))
);
const SettingsPage = lazy(() =>
  import("./pages/SettingsPage").then((m) => ({ default: m.SettingsPage }))
);
const AdminPage = lazy(() =>
  import("./pages/AdminPage").then((m) => ({ default: m.AdminPage }))
);
const UnlockPage = lazy(() =>
  import("./pages/UnlockPage").then((m) => ({ default: m.UnlockPage }))
);
const SystemPage = lazy(() =>
  import("./pages/SystemPage").then((m) => ({ default: m.SystemPage }))
);
const NotFoundPage = lazy(() =>
  import("./pages/NotFoundPage").then((m) => ({ default: m.NotFoundPage }))
);

const wrap = (Component: React.ComponentType) => (
  <LazyWrapper>
    <Component />
  </LazyWrapper>
);

export const placementRoutes: RouteObject[] = [
  { index: true, element: wrap(TodayPage) },
  { path: "home", element: wrap(TodayPage) },
  { path: "landing", element: wrap(LandingPage) },
  { path: "companies", element: wrap(CompaniesPage) },
  { path: "companies/:slug", element: wrap(CompanyDetailPage) },
  { path: "companies/:slug/bank", element: wrap(CompanyBankPage) },
  { path: "companies/:slug/bank/:qid", element: wrap(CompanyQuestionPage) },
  { path: "companies/:slug/recent", element: wrap(CompanyDetailPage) },
  {
    path: "companies/:slug/recent/:round",
    element: wrap(CompanyRecentRoundPage),
  },
  { path: "platforms", element: wrap(PlatformsPage) },
  { path: "platforms/:slug", element: wrap(PlatformDetailPage) },
  { path: "platforms/:slug/:problem", element: wrap(PlatformProblemPage) },
  { path: "practice/:company/:round/:set/:q", element: wrap(PracticePage) },
  { path: "dream-company", element: wrap(DreamCompanyPage) },
  { path: "dream-company/:slug", element: wrap(DreamCompanyPage) },
  { path: "radar/:slug", element: wrap(RadarPage) },
  { path: "debrief/:slug", element: wrap(RadarPage) },
  { path: "settings", element: wrap(SettingsPage) },
  { path: "settings/targets", element: wrap(SettingsPage) },
  { path: "settings/interviews", element: wrap(SettingsPage) },
  { path: "settings/security", element: wrap(SettingsPage) },
  { path: "settings/notifications", element: wrap(SettingsPage) },
  { path: "settings/privacy", element: wrap(SettingsPage) },
  { path: "settings/billing", element: wrap(SettingsPage) },
  { path: "admin", element: wrap(AdminPage) },
  { path: "admin/categories", element: wrap(AdminPage) },
  { path: "admin/companies", element: wrap(AdminPage) },
  { path: "admin/companies/:slug/roles", element: wrap(AdminPage) },
  { path: "admin/platforms", element: wrap(AdminPage) },
  { path: "admin/questions", element: wrap(AdminPage) },
  { path: "admin/videos", element: wrap(AdminPage) },
  { path: "admin/radar", element: wrap(AdminPage) },
  { path: "admin/users", element: wrap(AdminPage) },
  { path: "admin/payments", element: wrap(AdminPage) },
  { path: "admin/judge", element: wrap(AdminPage) },
  { path: "admin/flags", element: wrap(AdminPage) },
  { path: "admin/audit", element: wrap(AdminPage) },
  { path: "system", element: wrap(SystemPage) },
  { path: "unlock", element: wrap(UnlockPage) },
  { path: "recharge", element: wrap(UnlockPage) },
  { path: "sign-in", element: <Navigate to="/" replace /> },
  { path: "sign-up", element: <Navigate to="/" replace /> },
  { path: "select-role", element: <Navigate to="/placements" replace /> },
  { path: "reset", element: <Navigate to="/" replace /> },
  { path: "*", element: wrap(NotFoundPage) },
];
